import { useEffect, useState } from "react";

const KEY = "gtc:theme";
const initial = () => {
  const saved = localStorage.getItem(KEY);
  return saved ? saved === "dark" : window.matchMedia?.("(prefers-color-scheme: dark)").matches;
};

export const useTheme = () => {
  const [dark, setDark] = useState(initial);
  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem(KEY, dark ? "dark" : "light");
  }, [dark]);
  return [dark, () => setDark((d) => !d)];
};
